import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {formatDate} from "../util/helpers";
import {useNavigate} from "react-router-dom";
import dayjs from "dayjs";

const statusOptions = [
    { value: "", label: "모두" },
    { value: "REQUESTED", label: "정산 요청" },
    { value: "COMPLETED", label: "정산 완료" },
    { value: "REJECTED", label: "정산 실패" },
];

const displayStatus = (status) => {
    switch (status) {
        case "REQUESTED": return "정산 요청";
        case "COMPLETED": return "정산 완료";
        case "REJECTED": return "정산 실패";
        default: return status || "-";
    }
};

export default function WithdrawalMain() {
    const [status, setStatus] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();

    const load = () => {
        const params = {};
        if (status) params.status = status;
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        axios.get("/admin/v1/wallet/withdrawals", { params })
            .then(res => setRows(res.data || []));
    };

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">결제관리 &gt; 출금 요청</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                        <div className="card">
                                            <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm"
                                                    style={{marginRight: '10px'}}
                                                    onClick={() => navigate("/page/payments/withdrawals/summary")}
                                                >
                                                    정산관리(묶음)
                                                </button>

                                                <label className="col-sm-auto col-form-label" style={{marginLeft: '10px'}}>상태</label>
                                                <select className="form-control float-right"
                                                        style={{width: '160px', marginRight: '10px'}}
                                                        onChange={e => setStatus(e.target.value)}
                                                        value={status}>
                                                    {statusOptions.map(opt => (
                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                </select>

                                                <label className="col-sm-auto col-form-label" style={{marginLeft: '10px'}}>시작일</label>
                                                <input type="date" className="form-control float-right"
                                                       style={{width: '160px', marginRight: '10px'}}
                                                       value={startDate || ""}
                                                       onChange={e => setStartDate(e.target.value)} />
                                                <label className="col-sm-auto col-form-label" style={{marginLeft: '10px'}}>종료일</label>
                                                <input type="date" className="form-control float-right"
                                                       style={{width: '160px', marginRight: '10px'}}
                                                       value={endDate || ""}
                                                       onChange={e => setEndDate(e.target.value)} />

                                                <button type="button" className="btn btn-info btn-sm"
                                                        style={{width: '80px', marginLeft: '10px'}}
                                                        onClick={load}>
                                                    검색
                                                </button>
                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap" style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>정산요청ID</th>
                                                    <th>결제ID</th>
                                                    <th>사용자ID</th>
                                                    <th>정산금액</th>
                                                    <th>정산요청일시</th>
                                                    <th>정산완료일시</th>
                                                    <th>정산상태</th>
                                                    <th>보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {rows.map(row => (
                                                    <tr key={row.id}>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-link btn-sm p-0"
                                                                onClick={() => window.open(`/page/payments/withdrawals/detail?id=${row.id}`, '_blank', 'noopener')}
                                                            >
                                                                {row.id}
                                                            </button>
                                                        </td>
                                                        <td>
                                                            {row.paymentId ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link btn-sm p-0"
                                                                    onClick={() => window.open(`/page/payments/detail?id=${row.paymentId}`, '_blank', 'noopener')}
                                                                >
                                                                    {row.paymentId}
                                                                </button>
                                                            ) : "-"}
                                                        </td>
                                                        <td>
                                                            {row.memberId ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link btn-sm p-0"
                                                                    onClick={() => window.open(`/page/users/detail?userId=${row.memberId}`, '_blank', 'noopener')}
                                                                >
                                                                    {row.memberId}
                                                                </button>
                                                            ) : "-"}
                                                        </td>
                                                        <td>{row.amount.toLocaleString?.() || row.amount}</td>
                                                        <td>{formatDate(row.createdAt)}</td>
                                                        <td>{formatDate(row.processedAt)}</td>
                                                        <td>{displayStatus(row.status)}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-primary btn-sm"
                                                                onClick={() => navigate(`/page/payments/withdrawals/detail?id=${row.id}`)}
                                                            >
                                                                보기
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {rows.length === 0 && (
                                                    <tr>
                                                        <td colSpan={8}>출금 요청이 없습니다.</td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
